// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__20LcH","infoContainer":"Contact_infoContainer__2e5vd","logo":"Contact_logo__3IA47","tocTitleText":"Contact_tocTitleText__ffpiv"};